<template>
	<Layout>
		<Row class="bg-white">
			<Container>
				<img
					src="/images/500-img.svg"
					class="max-w-[320px] mx-auto mb-[32px]"
				/>
				<Heading
					tag="h2"
					class="text-center font-semibold mb-[16px]"
					text="OOPS! SEEMS WE HAVE SOME PROBLEMS"
				/>

				<p class="text-lg text-center mb-[32px]">
					We run into some internal problems, please try again later.
				</p>

				<Button
					label="Go To Homepage"
					class="mx-auto"
					type="link"
					to="/"
				/>
			</Container>
		</Row>
	</Layout>
	<Head>
		<Title>Internal Error - Timothy Sykes</Title>
		<Meta
			name="description"
			content="Timothy Sykes is a millionaire penny stock trader and entrepreneur. He is best known for earning $1.65 million by day trading while attending Tulane University."
		/>
	</Head>
</template>

<script setup>
import Layout from "~/layouts/error-layout.vue";
import { Container, Row, Heading } from "#components";

// eslint-disable-next-line
defineProps(["error"]);

</script>

<style scoped>
.site-container {
	background-color: #262930;
	background-size: inherit;
	background-repeat: no-repeat;
	background-position-x: 66%;
	background-position-y: -20%;
	color: #fff;
	width: auto;
}
.nav-404 {
	padding-top: 4rem;
}
.nav-404 span {
	color: #fff;
	font-size: 1.5rem;
	font-weight: 700;
}
.nav-404 span:hover {
	color: #3094fb;
}
.nav-404 a:hover {
	text-decoration: none;
	text-transform: none;
}

.content-404 {
	padding: 65px 0;
	margin-bottom: 32px;
}
.content-404 h1 {
	font-size: 150px;
	font-weight: 400;
}
.content-404 h5 {
	font-size: 20px;
	color: #fff;
	width: 100%;
	font-weight: 400;
}
.content-404 .blue-gradient-big {
	padding: 20px;
	margin-top: 50px;
}
.site-footer {
	padding-top: 25rem;
	border-top: none;
}
@media only screen and (min-width: 768px) {
	.content-404 h1 {
		font-size: 200px;
	}
}
.row {
	padding: 32px 0 !important;
}
@media only screen and (min-width: 1200px) {
	.row {
		padding: 64px 0 !important;
	}
}
</style>
